import React from 'react';
import classnames from 'classnames';
import Visa from 'images/icons/payment-logos/visa.svg?react-svg';
import MasterCard from 'images/icons/payment-logos/mastercard.svg?react-svg';
import Discover from 'images/icons/payment-logos/discover.svg?react-svg';
import AmEx from 'images/icons/payment-logos/amex.svg?react-svg';
import ApplePay from 'images/icons/payment-logos/apple-pay.svg?react-svg';
import GooglePay from 'images/icons/payment-logos/google-pay.svg?react-svg';
import Generic from 'images/icons/payment-logos/generic.svg?react-svg';
import { plainList } from 'scy/utils.mod.scss';

export default function PaymentLogo({ brand, width, height }) {
  switch (brand) {
    case 'Visa':
      return <Visa width={width || 28} height={height || 17} />;
    case 'MasterCard':
      return <MasterCard width={width || 28} height={height || 17} />;
    case 'Discover':
      return <Discover width={width || 28} height={height || 17} />;
    case 'American Express':
      return <AmEx width={width || 28} height={height || 17} />;
    case 'Apple Pay':
      return <ApplePay width={width || 28} height={height || 17} />;
    case 'Google Pay':
      return <GooglePay width={width || 28} height={height || 17} />;
    default:
      return <Generic width={width || 20} height={height || 15} />;
  }
}

export function PaymentLogoList({ className, itemClassName }) {
  return (
    <ul className={classnames(plainList, className)}>
      <li className={itemClassName}>
        <PaymentLogo brand="Visa" />
      </li>
      <li className={itemClassName}>
        <PaymentLogo brand="MasterCard" />
      </li>
      <li className={itemClassName}>
        <PaymentLogo brand="Discover" />
      </li>
      <li className={itemClassName}>
        <PaymentLogo brand="American Express" />
      </li>
      <li className={itemClassName}>
        <PaymentLogo brand="Apple Pay" />
      </li>
      <li className={itemClassName}>
        <PaymentLogo brand="Google Pay" />
      </li>
    </ul>
  );
}
